import { countrySettings } from '@change-corgi/config/legacy/countries'; // TODO move name ordering info to @change-corgi/config/countries

export function isSurnameBeforeGivenName({ countryCode }: Readonly<{ countryCode: string }>): boolean {
	return countrySettings[countryCode]?.surname_before_given_name ?? false;
}
